<template>
  <div class="container sitemap-container">
    <div class="logo-container">
      <img src="../assets/img/logo-icon.png" alt="">
    </div>
    <div class="three-col">
      <div class="col">
        <router-link to="/about"><p>About</p></router-link>
        <router-link to="/testimonials"><p>Testimonials</p></router-link>
      </div>
      <div class="col">
        <router-link to="/coaching"><p>Coaching</p></router-link>
        <router-link to="/blog"><p>Blog</p></router-link>
      </div>
      <div class="col">
        <p @click="openCalendly">Booking</p>
        <router-link to="/contact"><p>Contact</p></router-link>
      </div>
    </div>
  </div>
  
</template>

<script>

  // import '../calendly';
  export default {
    mounted() {
      let calendlyScript = document.createElement('script')
      calendlyScript.setAttribute('src', 'https://assets.calendly.com/assets/external/widget.js')
      document.head.appendChild(calendlyScript)
    },
    methods: {
      openCalendly() {
        
        Calendly.showPopupWidget('https://calendly.com/jackieserviss');
        return false;

        $('.calendly-overlay').style.zIndex="10000";

      }
    }
  }
  
</script>

<style>
  .sitemap-container {
    background-color: #3e3e3e;
    padding: 90px 0 130px 0;
    font-family: 'Helvetica', sans-serif
  }
  .logo-container { 
    margin: 0 auto 20px; 
    text-align: center;
  }

  .three-col {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
  }
  .col {
    width: 28%;
    color: #afb0d6;
    
  }

  .col p {
    font-size: 16px;
    cursor: pointer;
    transition: color 0.125s linear;
  }
  .col a {
    color: inherit;
    text-decoration: none;
    /*cursor: pointer;*/
    transition: color 0.125s linear;
  }
  .col a:hover,
  .col p:hover {
    color: #2e3192;
  }
</style>


// WEBPACK FOOTER //
// src/components/SiteMap.vue